import { __extends } from 'tslib';
import * as React from 'react';
import { classNames, validatePropType } from 'uitk-react-utils';
import styles from './uitk-badge.css';

var getClassNameList = classNames.bind(styles);
var UitkBadgeTheme;
(function (UitkBadgeTheme) {
    UitkBadgeTheme["DEAL_BUNDLED"] = "deal-bundled";
    UitkBadgeTheme["DEAL_GENERIC"] = "deal-generic";
    UitkBadgeTheme["DEAL_MEMBER"] = "deal-member";
    UitkBadgeTheme["NOTIFICATION_1"] = "notification-1";
    UitkBadgeTheme["NOTIFICATION_2"] = "notification-2";
    UitkBadgeTheme["VIP"] = "vip";
    UitkBadgeTheme["LOYALTY_HIGH_TIER"] = "loyalty_high_tier";
    UitkBadgeTheme["LOYALTY_MIDDLE_TIER"] = "loyalty_middle_tier";
    UitkBadgeTheme["LOYALTY_LOW_TIER"] = "loyalty_low_tier";
    UitkBadgeTheme["SPONSORED"] = "sponsored";
    UitkBadgeTheme["PROMOTED"] = "promoted";
    UitkBadgeTheme["VIEWED"] = "viewed";
    UitkBadgeTheme["SAVED"] = "saved";
    UitkBadgeTheme["FAMILY_FRIENDLY"] = "family-friendly";
    UitkBadgeTheme["SUPPLIER_PROMO"] = "supplier-promo";
})(UitkBadgeTheme || (UitkBadgeTheme = {}));
var UitkBadgeSize;
(function (UitkBadgeSize) {
    UitkBadgeSize["SMALL"] = "small";
    UitkBadgeSize["LARGE"] = "large";
})(UitkBadgeSize || (UitkBadgeSize = {}));
var UitkBadge = /** @class */ (function (_super) {
    __extends(UitkBadge, _super);
    function UitkBadge() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkBadge.prototype.render = function () {
        var _a, _b, _c;
        var _d = this.props, a11yText = _d.a11yText, className = _d.className, children = _d.children, text = _d.text, size = _d.size, theme = _d.theme;
        var wrapperClassNames = getClassNameList('uitk-badge', (_a = {},
            _a[UitkBadge.baseClassName + "-" + size] = validatePropType(size, UitkBadgeSize),
            _a), (_b = {},
            _b[UitkBadge.baseClassName + "-" + theme] = validatePropType(theme, UitkBadgeTheme),
            _b), (_c = {},
            _c[UitkBadge.baseClassName + "-has-text"] = text,
            _c), className);
        return (React.createElement("span", { className: wrapperClassNames },
            children,
            text && (React.createElement("span", { className: getClassNameList(UitkBadge.baseClassName + "-text"), "aria-hidden": !!a11yText }, text)),
            a11yText && React.createElement("span", { className: "is-visually-hidden" }, a11yText)));
    };
    UitkBadge.displayName = 'UitkBadge';
    UitkBadge.defaultProps = {
        size: UitkBadgeSize.LARGE,
        theme: UitkBadgeTheme.DEAL_GENERIC
    };
    UitkBadge.baseClassName = 'uitk-badge';
    return UitkBadge;
}(React.Component));

export { UitkBadge, UitkBadgeSize, UitkBadgeTheme };
